import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=1ab28abb"
import script from "./DataPrivacy.vue?vue&type=script&lang=ts"
export * from "./DataPrivacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports